module.exports = __webpack_public_path__ + "static/media/chemical3.2790cab3.jpg";